<app-loading *ngIf="isLoading" [onlyIcon]="true"></app-loading>
<ng-container *ngIf="!isLoading">
  <div class="new-contract-modal-sign__container-title">
    <h1 *ngIf="data.isDigital" class="new-contract-modal-sign__title">
      {{ 'NEW_CONTRACT_LA.DIGITAL_SIGN' | i18nextEager }}
    </h1>
    <img
      *ngIf="!sended"
      (click)="handleClose()"
      class="new-contract-modal-sign__cursor-pointer"
      src="/assets/icons/close.svg"
      alt="{{ 'COMMONS.CLOSE' | i18nextEager }}"
    />
  </div>
  <div *ngIf="data.isDigital && !sended" class="new-contract-modal-sign__paragraph">
    {{ 'NEW_CONTRACT_LA.SEND_CONTRACT_DIGITAL' | i18nextEager }}
  </div>
  <div
    *ngIf="data.isDigital && sended"
    class="new-contract-modal-sign__paragraph new-contract-modal-sign__paragraph--margin-bottom"
  >
    {{ 'NEW_CONTRACT_LA.SENDED_CONTRACT_DIGITAL' | i18nextEager }}
  </div>
  <div *ngIf="sended" class="new-contract-modal-sign__check">
    <img src="/assets/icons/big_check.svg" alt="{{ 'COMMONS.OK' | i18nextEager }}" />
  </div>
  <div class="new-contract-modal-sign__container-buttons">
    <ng-container *ngIf="!sended">
      <button class="quaternary new-contract-modal-sign__button" (click)="handleClose()">
        {{ 'COMMONS.CANCEL' | i18nextEager }}
      </button>
      <button class="new-contract-modal-sign__button" (click)="digitalSign()">
        {{ 'COMMONS.SEND' | i18nextEager }}
      </button>
    </ng-container>
    <button *ngIf="sended" class="new-contract-modal-sign__button" (click)="handleNavigate()">
      {{ 'COMMONS.OK' | i18nextEager }}
    </button>
  </div>
</ng-container>
